import { FormValidation } from "./FormValidation";

/**
 * Takes the parent validation class and ramps it up to 10.
 * Really it just adds some more methods specific to the donation flow.
 */
export class AccountValidation extends FormValidation {
    constructor(form: HTMLFormElement) {
        super(form);
    }

    /**
     * A version of check validation specific to the donation form.
     * This overrides the method in the parent class.
     */
    protected async checkValidation(formInput: HTMLInputElement | null) {
        // Make sure the element exists and can be validated. willValidate is needed for IE.
        if (!formInput || !formInput.willValidate) {
            return false;
        }

        if (formInput.id === "email") {
            await this.checkUsername(formInput);
        }

        if (formInput.id === "password") {
            this.checkPassword(formInput);
        }

        // All is well, no need to show error
        if (formInput.checkValidity()) {
            this.removeError(formInput);

            return true;
        }

        // Get an object of the forms validity state
        const validness = formInput.validity;

        if (validness.valueMissing) {
            this.showError(formInput);
        } else if (validness.typeMismatch) {
            this.showError(formInput, "Please enter a valid email.");
        } else if (validness.patternMismatch) {
            this.showError(formInput, "Please enter a valid phone number.");
        } else if (validness.tooShort) {
            this.determineLength(formInput);
        } else {
            this.showError(formInput, formInput.validationMessage);
        }
    }

    /**
     * Make sure the password does not contain repetitous characters.
     */
    private checkPassword(passwordField: HTMLInputElement) {
        // Checks if a character repeats 3 or more times
        const repeatingCharacters = /(\w)\1{2,}/.test(passwordField.value);

        if (repeatingCharacters) {
            return passwordField.setCustomValidity("The password cannot have repeated characters.");
        }

        return passwordField.setCustomValidity("");
    }
}
